<template>
  <div id="contenedor-tablero-expedientes-tool-bar" class="pb-4">
    <v-toolbar flat dense>
      <div style="width: 210px" class="mr-2">
        <DatePicker
          v-model="filtros.fechaInicio"
          label="Fecha inicial">
        </DatePicker>
      </div>
      <div style="width: 210px" class="mr-2">
        <DatePicker
          v-model="filtros.fechaFin"
          label="Fecha final">
        </DatePicker>
      </div>
      <div style="width: 220px" class="mr-2">
        <custom-select
          v-model="filtros.estatus"
          label="Estatus"
          item-value="id"
          item-text="nombre"
          clearable
          :items="getEstatus">
        </custom-select>
      </div>
      <div style="width: 240px" class="mr-2">
        <custom-select
          v-model="filtros.estadoExpediente"
          label="Estado del expediente"
          item-value="valor"
          item-text="nombre"
          clearable
          :items="estadosExpediente">
        </custom-select>
      </div>

      <FiltrosSecundarios
        :filtros="filtros"
        :datosCompletos="datosCompletos">
      </FiltrosSecundarios>

      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" @click="limpiarFiltros">
            <v-icon>mdi-filter-remove-outline</v-icon>
          </v-btn>
        </template>
        <span>Limpiar filtros</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <ExcelTableroExpedientes
        :resultados="resultados"
        :filtros="filtros">
      </ExcelTableroExpedientes>
    </v-toolbar>
  </div>
</template>

<script>
import DatePicker from '@/components/inputs/DatePicker.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import ExcelTableroExpedientes from '@/components/exportar/exceles/ExcelTableroExpedientes.vue';
import { ESTADOS_EXPEDIENTE } from '@/helpers/expedienteEstados';
import FiltrosSecundarios from './FiltrosSecundarios.vue';

export default {
  name: 'TableroExpedientesToolBar',
  props: {
    filtros: {
      type: Object,
      required: true,
    },
    datosCompletos: {
      type: Array,
      required: true,
    },
    resultados: {
      type: Array,
      required: true,
    },
  },
  components: {
    DatePicker,
    CustomSelect,
    ExcelTableroExpedientes,
    FiltrosSecundarios,
  },
  data() {
    return {
      estadosExpediente: ESTADOS_EXPEDIENTE,
    };
  },
  methods: {
    limpiarFiltros() {
      this.$emit('limpiar-filtros');
    },
  },
  computed: {
    getEstatus() {
      const estatus = this.datosCompletos
        .map(({ estatus: estatusContrato }) => estatusContrato)
        .filter((estatusContrato) => !!estatusContrato);
      return this.$removerDumplicadosArrayObj(estatus, 'id')
        .sort((a, b) => a.nombre.localeCompare(b.nombre));
    },
  },
};
</script>

<style lang="scss">
</style>
